<script lang="ts">
    import {TabList} from '@rgossiaux/svelte-headlessui';
</script>

<TabList class="kp-generic-tab-list">
    <slot/>
</TabList>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    @vertical-spacing: 6px;
    @horizontal-spacing: 8px;

    :global {
        .kp-generic-tab-list {
            width: 100%;
            display: flex;
            gap: @horizontal-spacing;
            flex-wrap: wrap;
            border-radius: @border-radius-base;
            border: 1px solid @table-border-color;
            background-color: @panel-default-heading-bg;
            padding: @vertical-spacing @horizontal-spacing;
        }
    }
</style>